import '~/controllers/frontend'

import * as Turbo from '@hotwired/turbo'
Turbo.start()

Turbo.StreamActions.redirect = function () {
    Turbo.visit(this.target);
};